import { Link } from "gatsby"
import React from "react"
import { Container, Nav, Navbar } from "react-bootstrap"
import FeedbackButton from "./FeedbackButton"

export default function Layout({ children }) {
  return (
    <div>
        <FeedbackButton/>
        <Navi/>
        {children}
    </div>
  )
}

const Navi = () => {
    return (
        <Navbar collapseOnSelect expand="lg" bg="dark" variant="dark">
            <Container>
            <Navbar.Brand>
                <Link to="/" className="text-decoration-none text-light">
                    <span className="fw-bold">ProxiMovie</span> <em className="text-secondary">What to watch next</em>
                </Link>
            </Navbar.Brand>
            {/* <Navbar.Toggle aria-controls="responsive-navbar-nav" />
            <Navbar.Collapse id="responsive-navbar-nav">
                <Nav className="me-auto">
                <Nav.Link href="#features">Features</Nav.Link>
                <Nav.Link href="#pricing">Pricing</Nav.Link>
                <NavDropdown title="Dropdown" id="collasible-nav-dropdown">
                    <NavDropdown.Item href="#action/3.1">Action</NavDropdown.Item>
                    <NavDropdown.Item href="#action/3.2">Another action</NavDropdown.Item>
                    <NavDropdown.Item href="#action/3.3">Something</NavDropdown.Item>
                    <NavDropdown.Divider />
                    <NavDropdown.Item href="#action/3.4">Separated link</NavDropdown.Item>
                </NavDropdown>
                </Nav>
                <Nav>
                <Nav.Link href="#deets">More deets</Nav.Link>
                <Nav.Link eventKey={2} href="#memes">
                    Dank memes
                </Nav.Link>
                </Nav>
            </Navbar.Collapse> */}
            </Container>
        </Navbar>

    )
}